import {Box, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import {AudiencesSummary, Fields, formatMsk, Section} from "../../Summary/SummaryParts";

const yesNo = (value) => value ? 'Yes' : 'No';

/** Шаг "summary" AB-теста — в том же виде, что и у кампаний. */
export default function SummaryStep({currentAbTest: abTest}) {
    return (
        <Box>
            <Section title="Basic">
                <Fields rows={[
                    ["ID:", abTest.abTestId],
                    ["Group:", abTest.groupId],
                    ["Priority:", abTest.priority],
                    ["Reassign Cohort:", yesNo(abTest.reassignCohort)],
                    ["Assign Cohort By Payments:", yesNo(abTest.assignCohortByPayments)],
                    ["From:", formatMsk(abTest.from)],
                    ["Till:", formatMsk(abTest.till)],
                    abTest.metaData?.link ? ["Link:", abTest.metaData.link] : null,
                ]}/>
            </Section>

            <Section title="Cohorts">
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Id</TableCell>
                            <TableCell>Active</TableCell>
                            <TableCell>Weight</TableCell>
                            <TableCell>Limit</TableCell>
                            <TableCell>User groups</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {abTest.cohorts.map((cohort, index) => (
                            <TableRow key={cohort.uuid || index}>
                                <TableCell>{cohort.id}</TableCell>
                                <TableCell>{cohort.active ? 'active' : 'inactive'}</TableCell>
                                <TableCell>{cohort.weight}</TableCell>
                                <TableCell>{cohort.limit}</TableCell>
                                <TableCell>{(cohort.userGroup || []).join(', ')}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Section>

            <Section title="Audiences">
                <AudiencesSummary audiences={abTest.audiences}/>
            </Section>
        </Box>
    );
}
